import { datadogRum } from "@datadog/browser-rum";

import packageInfo from "../../package.json";

const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID || "";
const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "";
const env = process.env.REACT_APP_ENV;

function assertEnv(name: string) {
  if (!process.env[name] && env && ["preprod", "production"].includes(env)) {
    const error = new Error(`The "${name}" environment variable is required`);
    error.name = "AssertionError";
    throw error;
  }
}

export const startDatadogRumSession = () => {
  if (!applicationId || !clientToken) return;

  assertEnv("REACT_APP_DATADOG_APPLICATION_ID");
  assertEnv("REACT_APP_DATADOG_CLIENT_TOKEN");

  datadogRum.init({
    applicationId,
    clientToken,
    env,
    site: "datadoghq.com",
    service: "sierra",
    version: packageInfo.version,
    sampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackInteractions: true,
    trackFrustrations: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingOrigins: [process.env.REACT_APP_CORE_API || "", process.env.REACT_APP_WAREHOUSE_API || ""],
  });

  return datadogRum.startSessionReplayRecording();
};
